
import {computed, defineComponent, provide} from "vue";
import { useStore } from "vuex";
import { Actions } from "@/store/enums/StoreEnums";
import router from "@/router";
import {useI18n} from "vue-i18n";
import { parse } from "vue-currency-input";
import posthog from '@/posthog';

export default defineComponent({
  name: "oauth",
  props: {
    provider: {
      type: String,
      default: null,
    },
  },
  components: {},
  created: function () {
    this.startSSO(this.provider);
  },
  setup() {

    const store = useStore();
    const { t } = useI18n();

    const currentLanguage = computed(() => store.getters.getCurrentLanguage || localStorage.getItem('currentLanguage'));

    const parseParams = (querystring) => {
      // parse query string
      const params = new URLSearchParams(querystring);
      const obj = {};
      params.forEach((v, k) => {
        obj[k] = v;
      });

     
      return obj;
    };

    const GoogleAuth = () => {
      const data : any = parseParams(window.location.search);
      // read local storage for checkout redirect
      if(localStorage.getItem('checkout_redirect')){
        window.location.href = process.env.VUE_APP_GOOGLE_REDIRECT_URI_CHECKOUT + window.location.search;
      }else{
      store
        .dispatch(Actions.LOGIN_SSO, {
          provider: "google",
          credentials: data,
        })
        .then(() => {
          router.push("/dashboard");
        });
      }
    };
    const FacebookAuth = () => {
      const data = parseParams(window.location.search);
      
      store
        .dispatch(Actions.LOGIN_SSO, {
          provider: "facebook",
          credentials: data,
        })
        .then(() => {
          router.push("/dashboard");
        });
    };
    const GithubAuth = () => {
      const data : any = parseParams(window.location.search);
      
      if(localStorage.getItem('checkout_redirect')){
        window.location.href = process.env.VUE_APP_GITHUB_REDIRECT_URI_CHECKOUT + window.location.search;
      }else{
        store
        .dispatch(Actions.LOGIN_SSO, {
          provider: "github",
          credentials: data,
        })
        .then(() => {
          router.push("/dashboard");
        });
      }
    };

    const startSSO = (provider) => {
      switch (provider) {
        case "google":
          GoogleAuth();
          break;
        case "facebook":
          FacebookAuth();
          break;
        case "github":
          GithubAuth();
          break;
        default:
          break;
      }
    };
    return {
      startSSO,
      currentLanguage
    };
  },
});
